import styled from "styled-components";

export const MonsterTopParams = styled.div.attrs({
  className: `
  absolute 
  top-0 
  left-0 
  right-0 
  bg-main/70 
  rounded-t-xl 
  pt-2.5
  pb-2 
  px-1 
  text-center 
  text-sm`,
})``;

export const MonsterBottomParams = styled.div.attrs({
  className: `
  absolute 
  bottom-[100px]
  left-0 
  right-0 
  bg-main/70
  rounded-b-xl 
  pt-2.5
  pb-3 
  px-1 
  text-center 
  text-sm`,
})``;
